// extracted by mini-css-extract-plugin
var _1 = "actionCall__vE8BO";
var _2 = "buttonWrapper__TvX6J";
var _3 = "container__Dv8JT";
var _4 = "markText__Beech";
var _5 = "subtitle__MxT1d";
var _6 = "title__hO3aE";
var _7 = "titleWrapper__lpf3T";
export { _1 as "actionCall", _2 as "buttonWrapper", _3 as "container", _4 as "markText", _5 as "subtitle", _6 as "title", _7 as "titleWrapper" }
export default { "actionCall": _1, "buttonWrapper": _2, "container": _3, "markText": _4, "subtitle": _5, "title": _6, "titleWrapper": _7 }
